export const randomId = () => +new Date() + '_' + Math.random().toString(36).substring(4);
